import { Action } from '@ngrx/store';
import { type } from '../util';
import { Flight } from '@ibe/models';

export const ActionTypes = {
	LOADING: type('[TotalSummary] loading '),
	PUT_ITENS_SUMMARY: type('[TotalSummary] put priceUnit'),
	RESET: type('[TotalSummary] reset')
};

export class LoadingAction implements Action {
	type = ActionTypes.LOADING;

	/**
	 *Creates an instance of LoadingAction.
	 * @param {*} [payload]
	 * @memberof LoadingAction
	 */
	constructor(public payload?) { }
}

export class PutItensSummary implements Action {
	type = ActionTypes.PUT_ITENS_SUMMARY;

	/**
	 *Creates an instance of PutItensSummary.
	 * @param {Array<>} payload
	 * @memberof PutItensSummary
	 */
	constructor(public payload: { flights: Flight[], summary: Array<{ item: string, label: string, value: string, total: string }> }) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;

	/**
	 *Creates an instance of ResetAction.
	 * @param {*} [payload]
	 * @memberof ResetAction
	 */
	constructor(public payload?) { }
}

export type Actions = LoadingAction | PutItensSummary | ResetAction;
